import React, { useMemo, useState, useCallback } from "react";
import { filterVenues } from "../../../utils/data";
import { CreativeMarkdown } from "../../common/CreativeMarkdown";
import { Expandable } from "../../common/Expandable";
import { FilterObject, FilterOptions } from "../../common/FilterOptions";
import { Title } from "../../common/Title";
import { VenueCard } from "../../common/VenueCard";
import { useAppContext } from "../../Context/AppContext";
import { VenueCardFragment } from "../Map";

import styles from "./VenueDirectory.module.scss";

interface VenueDirectoryProps {
  items: VenueCardFragment[];
  content: string;
}

const VenueDirectory: React.FC<VenueDirectoryProps> = ({ items, content }) => {
  const { animating } = useAppContext();
  const [filterOptions, setFilterOptions] = useState<FilterObject>({});
  const [showFilters, setShowFilters] = useState(false);

  const venues = useMemo(() => {
    return filterVenues(items, filterOptions);
  }, [filterOptions, items]);

  const onFilter = useCallback(filterObject => {
    setFilterOptions(filterObject);
  }, []);

  return (
    <section className={styles.wrapper}>
      <div className={styles.left}>
        <Title className={styles.title} size="large">
          Venues
        </Title>
        <CreativeMarkdown options={{ forceBlock: true }}>
          {content}
        </CreativeMarkdown>

        <div className={styles.filters}>
          <Title
            className={styles.filtersTitle}
            size="small"
            tagName="span"
            role="button"
            onClick={() => setShowFilters(!showFilters)}
          >
            Filter {showFilters ? "-" : "+"}
          </Title>
          <Expandable open={showFilters}>
            <FilterOptions onFilter={onFilter} />
          </Expandable>
        </div>
      </div>

      <div className={styles.right}>
        {venues.map((venue, idx) => (
          <VenueCard
            key={venue.slug}
            {...venue}
            number={venue.number}
            className={styles.card}
            display={!animating}
          >
            {venue.description}
          </VenueCard>
        ))}
      </div>
    </section>
  );
};

export { VenueDirectory };
